import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendOktaPush } from 'services/pod';
import { ISendPushNotificationPayload } from 'services/pod/types';

export const ThunkSendOktaPush = createAsyncThunk(
  'pod/sendOktaPush',
  async (payload: ISendPushNotificationPayload) => sendOktaPush(payload).then(res => res.data),
);
